// La ÚNICA lectura que arma la tabla de Clientes: `GET /backoffice/credit-customers`, el BFF de
// `loan-credit-business`. Trae padrón, cartera y segmentos ya cruzados y paginados con cursor opaco.
//
// El front acumula páginas y filtra, ordena y pagina sobre lo acumulado: mientras `hasNextPage` siga
// en `true` la tabla NO tiene el padrón completo, y la pantalla lo declara (ESTANDAR-TABLAS §5.4).
import { useInfiniteQuery } from '@tanstack/react-query';
import { listCreditCustomers, type CreditCustomersPage } from '@/api/services/loan-credit';

const KEY = ['credit-admin', 'customers'] as const;

/** Filas por página del servidor. La paginación que ve el analista es la de lo ya cargado. */
export const CREDIT_CUSTOMERS_PAGE_SIZE = 25;

const STALE_TIME_MS = 60_000;

/**
 * Las páginas de clientes acumuladas. El cursor se pasea tal cual: la ausencia de `nextToken` es lo
 * único que marca el fin de la lista, nunca una página corta.
 */
export function useCreditCustomers() {
    return useInfiniteQuery({
        queryKey: [...KEY, 'list'],
        queryFn: ({ pageParam }: { pageParam: string | undefined }): Promise<CreditCustomersPage> =>
            listCreditCustomers({ limit: CREDIT_CUSTOMERS_PAGE_SIZE, nextToken: pageParam }),
        initialPageParam: undefined as string | undefined,
        getNextPageParam: (last) => last.nextToken,
        staleTime: STALE_TIME_MS,
    });
}
